import React from "react";
import {Button} from "reactstrap";
import Loader from "../../../components/Loader";

const RenderEmpty = ({ioTypes, modalHandler}) => {
  return (
    <>
      <Loader />
      <div className="empty--summary">
        <div
          style={{
            fontSize: "16px",
            color: "#303030",
            fontWeight: "bold",
            marginBottom: "20px",
          }}
          className="d-flex justify-content-center roboto-bold"
        >
          Lets Get Started!
        </div>
        <div className="d-flex justify-content-center add--sensor--button">
          {ioTypes.map((ioType) => (
            <Button
              key={ioType.value}
              onClick={() => modalHandler(ioType.value)}
              style={{marginLeft: "15px", marginRight: "0px"}}
              className="btn_common roboto-bold"
              data-cy={`ADD_${ioType.label}`}
            >
              {`ADD ${ioType.label}`}
            </Button>
          ))}
        </div>
      </div>
    </>
  );
};

export default RenderEmpty;
